<template>
  <div
    v-if="isShow"
    class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center p-4 z-50"
  >
    <div class="confirm-dialog max-w-[512px] w-full shadow-lg rounded-md bg-white">
      <h3 class="ml-6 mt-7 mb-4">
        {{ title }}
      </h3>
      <p class="ml-6 mr-6 mb-5 text-zyxel-gray-800">
        {{ description }}
      </p>
      <div class="modal-footer hidden sm:flex justify-end">
        <button
          class="ml-3 mb-4 mr-4 button-primary min-w-[120px]"
          @click="close"
        >
          {{ $t("messages.button.ok") }}
        </button>
      </div>
      <div class="modal-footer flex-col sm:hidden p-6">
        <button
          class="button-primary w-full mb-4"
          @click="close"
        >
          {{ $t("messages.button.ok") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GeneralDialog",
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    }
  },
  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>